import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getNews = createAsyncThunk('getNews/getNews', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getNews(payload.limit, payload.sort);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
